import { defineMessages } from 'react-intl';

export default defineMessages({
  freeShipping: {
    id: 'components.ProductVariantInfo.freeShipping',
    defaultMessage: 'Free Shipping',
  },
  downloadStock: {
    id: 'components.ProductVariantInfo.downloadStock',
    defaultMessage: 'Download: Available immediately',
  },
  inStock: {
    id: 'components.ProductVariantInfo.inStock.title',
    defaultMessage: 'In Stock',
  },
  inStockDescription: {
    id: 'components.ProductVariantInfo.inStock.description',
    defaultMessage: 'Usually ships in 1-2 business days.',
  },
  lowStock: {
    id: 'components.ProductVariantInfo.lowStock.title',
    defaultMessage: 'Low Stock',
  },
  lowStockDescription: {
    id: 'components.ProductVariantInfo.lowStock.description',
    defaultMessage:
      'Stock is low - order now! Will ship in one or two business days.',
  },
  outOfStock: {
    id: 'components.ProductVariantInfo.outOfStock.title',
    defaultMessage: 'Out of stock',
  },
  outOfStockDescription: {
    id: 'components.ProductVariantInfo.outOfStock.description',
    defaultMessage: 'Product is out of stock',
  },
  preOrder: {
    id: 'pages.pricing.preOrderMessage',
    defaultMessage: 'Download: Pre-order now & start using from {date}',
  },
  preOrderHardware: {
    id: 'pages.pricing.preOrderMessageHW',
    defaultMessage: 'Pre-order now. Available from {date}',
  },
});
